import {logger, MetaObject} from 'tizra'
import {useMetaObj, UseMetaObjProps} from './useMetaObj'
import {useTypeDefs} from './useTypeDefs'

const log = logger('quickstart/hooks/useMetaObjInfo')

type UseMetaObjInfoProps<T extends MetaObject> = UseMetaObjProps<T>

/**
 * Fetch a metaObj with its typeDefs and metaType from the API.
 */
export const useMetaObjInfo = <T extends MetaObject>(
  props: UseMetaObjInfoProps<T>,
) => {
  const metaObj = useMetaObj(props)
  const metaType = metaObj?.metaType || props?.metaType
  const tizraId = metaObj?.tizraId || props?.tizraId
  const typeDefs = useTypeDefs(metaType)

  return {metaObj, metaType, tizraId, typeDefs}
}
